var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/_cof.js
// module id = 18
// module chunks = 0